export default __webpack_public_path__ + "static/media/startups.fb209613.svg";